module.exports = __webpack_public_path__ + "static/media/section1Image1.9afa3996.gif";